import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import { Modal } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

interface RatingModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function RatingModal({ open, onClose, setOpen }: RatingModalProps) {
  return (
    <Modal
      className="modal fcDetail_modal"
      id="fcDetailModal"
      aria-labelledby="fcDetail-modal-title"
      aria-describedby="fcDetail-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Rating and Reviews</h2>
          </div>
          <div className="fcustomer_info gap_m">
            <div className="left_s">
              <figure className="blog_dtl_img" style={{ maxHeight: '350px', position: 'relative' }}>
                <img src="/static/images/vehicle_side.jpg" alt="fcImage" />
                <div
                  className="star_rating"
                  style={{ position: 'absolute', top: '16px', right: '16px' }}
                >
                  <StarIcon className="active" />
                  <StarIcon className="active" />
                  <StarIcon className="active" />
                  <StarIcon className="active" />
                  <StarIcon />
                </div>
              </figure>
            </div>
            <div className="right_s">
              <div className="fcComment_box">
                <h2>User Details</h2>
                <ul className="fcComment_list">
                  <li>
                    <figure style={{ height: '50px', width: '50px' }}>
                      <img src="/static/images/user_attachment.jpg" alt="" />
                    </figure>
                    <p>
                      <b>Emma Smith</b> +9203024595467 <br />
                      emma@gmail.com
                    </p>
                  </li>
                </ul>
              </div>
              <div className="details_md">
                <h3>Review</h3>
                <p>
                  It is a long established fact that a reader will be distracted by the readable
                  content of a page when looking at its layout. The point of using Lorem Ipsum is
                  that it has a more-or-less normal distribution of letters, as opposed to using
                  'Content here, content here
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
